// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__iNdEz","footer-content":"Footer_footer-content__Zd3kA","icon":"Footer_icon__AR7oL","logo":"Footer_logo__eQuKj"};